import { Controls, Player } from '@lottiefiles/react-lottie-player';
import { IconEye, IconEyeClosed } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { postApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { encryptLocalStorage } from '../../utils/localStorage.utils';
import { getAccessList, getAllCategories, getAllLanguages, getAppLanguageList } from '../../api/api.global';
import { ACCESS_LIST } from '../../statics/localStorage';

const Login = () => {

  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    encryptLocalStorage('advy-admin-token', '')
    return () => {

    };
  }, []);

  const login = async (e) => {
    e.preventDefault();
    loadingShow();
    let postData = {
      "phone": document.getElementById('mobile').value,
      "password": document.getElementById('password').value
    }
    let resp = await postApi(postData, urlApi.login);
    loadingHide();
    if (resp.responseCode === 200) {
      getAppLanguageList();
      getAllCategories();
      getAllLanguages()
      await getAccessList();
      encryptLocalStorage("profile", resp.data);
      encryptLocalStorage("uid", resp.data?._id);
      if (ACCESS_LIST()) {
        navigate("/admin-profile");
      }
    } else {
      toast.error(resp?.message);
    }
  }

  return (
    <div className='container flex flex-col justify-center items-center h-dvh'>

      <div className="rounded-xl hidden md:block -mt-48">
        <Player src={process.env.PUBLIC_URL + "/assets/animation/login.json"} background="rgba(0, 0, 0, 0)" speed="1" loop autoplay style={{ height: 500 }}>
          <Controls visible={false} />
        </Player>
      </div>

      <div className='login-form w-full md:w-1/3 flex flex-col gap-2 p-[34px] bg-gray-200 rounded-3xl'>

        <img src={process.env.PUBLIC_URL + "/assets/images/icon-logo.png"} alt="" className='w-max h-16 rounded-xl mx-auto mb-2' />

        <h1 className='mb-12 text-center font-bold uppercase text-[38px]'>Login</h1>

        <form onSubmit={login} className='flex flex-col'>

          <input type="tel" autoFocus placeholder="Mobile" required id='mobile' className='bg-transparent text-sm p-[10px] rounded-2xl border-b-2 mb-3 px-4 focus:outline-none shadow-lg text-black' />

          <div className='flex items-center px-3 shadow-lg rounded-2xl border-b-2 mb-8'>
            <input type={isVisible ? "text" : "password"} placeholder="Password" id='password' required className='bg-transparent grow text-sm p-[10px] focus:outline-none' />
            {isVisible ? <IconEye onClick={() => setIsVisible(false)} className='cursor-pointer' /> : <IconEyeClosed className='cursor-pointer' onClick={() => setIsVisible(true)} />}
          </div>

          <button className='w-full py-[8px] bg-[var(--secondary)] rounded-2xl font-semibold text-lg text-white'>Login</button>

        </form>

      </div>
    </div>
  )
}

export default Login